"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloomingVale = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const TileType_1 = require("../../../TileType");
const Resources_1 = require("../../../Resources");
class BloomingVale {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.BLOOMING_VALE;
        this.description = 'Gain 1 plant for each greenery tile (max 5) and influence.';
        this.revealedDelegate = PartyName_1.PartyName.BUREAUCRATS;
        this.currentDelegate = PartyName_1.PartyName.TRANSHUMANS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const greeneryCount = game.board.spaces.filter((space) => {
                return space.tile && space.tile.tileType === TileType_1.TileType.GREENERY && space.player !== undefined && space.player.id === player.id;
            }).length;
            const amount = Math.min(greeneryCount, 5) + turmoil.getPlayerInfluence(player);
            player.addResource(Resources_1.Resources.PLANTS, amount, { log: true });
        });
    }
}
exports.BloomingVale = BloomingVale;
//# sourceMappingURL=BloomingVale.js.map